// TODO Rename to basket once we remove old basket
import {action, observable, runInAction} from 'mobx';
import * as Sentry from '@sentry/react';

import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';

import isValidException from 'utils/isValidException';

class BasketsSummaryState extends APIRequestState {
  getRequest() {
    return this.ctx.sdk.get('/baskets/active/summary');
  }
}

class BasketsOverviewState extends APIRequestState {
  getRequest() {
    return this.ctx.sdk.get('/baskets/active/appointments/active');
  }
}

class BasketsPricingState extends APIRequestState {
  getRequest() {
    return this.ctx.sdk.get('/baskets/active/pricing');
  }
}

class BasketsAppointmentsAddressState extends APIRequestState {
  putRequest(queryParams, ...params) {
    return this.ctx.sdk.post(`/baskets/active/appointments/address?${queryParams}`, ...params);
  }
}

class BasketsAppointmentsServicesState extends APIRequestState {
  putRequest(urlId, ...params) {
    return this.ctx.sdk.post(`/baskets/active/appointments/active/services${urlId ? `/${urlId}` : ''}`, ...params);
  }
}

class BasketsAppointmentsSlotsUpdateState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.patch('/baskets/active/appointments/active/slots', ...params);
  }
}

class BasketsAppointmentWorkerUpdateState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.patch('/baskets/active/appointments/active/worker', ...params);
  }
}

class BasketsAppointmentsDatesSelectState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.patch('/baskets/active/appointments/active/selected-date', ...params);
  }
}

class BasketsAppointmentsSlotsDeleteState extends APIRequestState {
  putRequest() {
    return this.ctx.sdk.delete('/baskets/active/appointments/active/slots');
  }
}

class BasketsAppointmentsServicesDeleteState extends APIRequestState {
  putRequest(urlId) {
    return this.ctx.sdk.delete(`/baskets/active/appointments/active/services/${urlId}`);
  }
}

class BasketsAppointmentsWorkerDeleteState extends APIRequestState {
  putRequest(urlId) {
    return this.ctx.sdk.delete('/baskets/active/appointments/active/worker');
  }
}

class BasketsCheckoutState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.post('/baskets/active/checkout', ...params);
  }
}

class BasketsComplete3DSState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.post('/baskets/active/complete-3d-secure', ...params);
  }
}

class BasketsGetAppointmentsState extends APIRequestState {
  getRequest(urlId) {
    return this.ctx.sdk.get(`/baskets/${urlId}/appointments`);
  }
}

class BasketsGetDiscountsState extends APIRequestState {
  getRequest(urlId) {
    // return this.ctx.sdk.get(`/baskets/${urlId}/appointments`);
    return this.ctx.sdk.get(`/baskets/active/available-discounts`);
  }
}

class BasketsAppointmentsPutDiscountState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.patch(`/baskets/active/discount`, ...params);
  }
}

class BasketsAppointmentsDeleteDiscountState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.delete(`/baskets/active/discount`, ...params);
  }
}

class BasketsGetAppointmentAddressState extends APIRequestState {
  getRequest() {
    return this.ctx.sdk.get('/baskets/active/appointments/active/address');
  }
}

class BasketsSetAppointmentSavedAddressState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.patch('/baskets/active/appointments/active/address', ...params);
  }
}

class BasketsConfirmAppointmentsAddressState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.post(`/baskets/active/appointments/active/address-confirm`, ...params);
  }
}

class BasketsGetPaymentMethodsState extends APIRequestState {
  getRequest() {
    return this.ctx.sdk.get('/baskets/active/payment-methods');
  }
}

class BasketsGetCancellationPolicyState extends APIRequestState {
  getRequest() {
    return this.ctx.sdk.get('/baskets/active/cancellation-policy');
  }
}

class BasketsGetCheckoutPreviewState extends APIRequestState {
  getRequest() {
    return this.ctx.sdk.get('/baskets/active/checkout-preview');
  }
}

class BasketsRedeemPromoCodeState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.post('/baskets/active/redeem-code', ...params);
  }
}

class BasketsRebookAppointmentState extends APIRequestState {
  putRequest(appointmentId) {
    return this.ctx.sdk.post(`/appointments/${appointmentId}/clone-to-basket`);
  }
}

class BasketsRebookAppointmentWithSlotState extends APIRequestState {
  putRequest(appointmentId) {
    return this.ctx.sdk.post(`/appointments/${appointmentId}/clone-speciality-slot-to-basket`);
  }
}

class BasketsDeleteActiveBasketState extends APIRequestState {
  putRequest() {
    return this.ctx.sdk.delete('/baskets/active');
  }
}

class BasketsGetWorkerPreValidateState extends APIRequestState {
  getRequest(workerId) {
    return this.ctx.sdk.get(`/baskets/active/appointments/active/worker/${workerId}/pre-validate`);
  }
}

class BasketsGetDurationsListState extends APIRequestState {
  getRequest(serviceId) {
    return this.ctx.sdk.get(`baskets/active/appointments/active/services/${serviceId}/durations`);
  }
}

class BasketsUpdateDurationState extends APIRequestState {
  putRequest(serviceId, ...params) {
    return this.ctx.sdk.patch(`/baskets/active/appointments/active/services/${serviceId}/duration`, ...params);
  }
}

class BasketNewState {
  @lazyInitialize @nonenumerable basketsSummary = new BasketsSummaryState(this.ctx);
  @lazyInitialize @nonenumerable basketsGetFull = new BasketsOverviewState(this.ctx);
  @lazyInitialize @nonenumerable basketGetPricing = new BasketsPricingState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentsAddress = new BasketsAppointmentsAddressState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentsServices = new BasketsAppointmentsServicesState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentsServicesDelete = new BasketsAppointmentsServicesDeleteState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentsDateUpdate = new BasketsAppointmentsDatesSelectState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentsSlotsUpdate = new BasketsAppointmentsSlotsUpdateState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentsSlotsDelete = new BasketsAppointmentsSlotsDeleteState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentWorkerUpdate = new BasketsAppointmentWorkerUpdateState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentsWorkerDelete = new BasketsAppointmentsWorkerDeleteState(this.ctx);
  @lazyInitialize @nonenumerable basketsCheckout = new BasketsCheckoutState(this.ctx);
  @lazyInitialize @nonenumerable basketsComplete3DS = new BasketsComplete3DSState(this.ctx);
  @lazyInitialize @nonenumerable basketsGetAppointments = new BasketsGetAppointmentsState(this.ctx);
  @lazyInitialize @nonenumerable basketsGetDiscounts = new BasketsGetDiscountsState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentsPutDiscount = new BasketsAppointmentsPutDiscountState(this.ctx);
  @lazyInitialize @nonenumerable basketsAppointmentsDeleteDiscount = new BasketsAppointmentsDeleteDiscountState(this.ctx);
  @lazyInitialize @nonenumerable basketsGetAppointmentAddress = new BasketsGetAppointmentAddressState(this.ctx);
  @lazyInitialize @nonenumerable basketsSetAppointmentSavedAddress = new BasketsSetAppointmentSavedAddressState(this.ctx);
  @lazyInitialize @nonenumerable basketsConfirmAppointmentAddress = new BasketsConfirmAppointmentsAddressState(this.ctx);
  @lazyInitialize @nonenumerable basketsGetPaymentMethods = new BasketsGetPaymentMethodsState(this.ctx);
  @lazyInitialize @nonenumerable basketsGetCancellationPolicy = new BasketsGetCancellationPolicyState(this.ctx);
  @lazyInitialize @nonenumerable basketsGetCheckoutPreview = new BasketsGetCheckoutPreviewState(this.ctx);
  @lazyInitialize @nonenumerable basketsRedeemPromoCode = new BasketsRedeemPromoCodeState(this.ctx);
  @lazyInitialize @nonenumerable basketsRebookAppointment = new BasketsRebookAppointmentState(this.ctx);
  @lazyInitialize @nonenumerable basketsRebookAppointmentWithSlot = new BasketsRebookAppointmentWithSlotState(this.ctx);
  @lazyInitialize @nonenumerable basketsDeleteActiveBasket = new BasketsDeleteActiveBasketState(this.ctx);
  @lazyInitialize @nonenumerable basketsWorkerPreValidate = new BasketsGetWorkerPreValidateState(this.ctx);
  @lazyInitialize @nonenumerable basketsGetDurationsList = new BasketsGetDurationsListState(this.ctx);
  @lazyInitialize @nonenumerable basketsUpdateDuration = new BasketsUpdateDurationState(this.ctx);

  @observable basketFormattedAddress;
  @observable basketHasAddress = false;
  @observable basketServiceCount = 0;
  @observable basketHasStartsAt = false;
  @observable basketHasWorker = false;

  @action reset() {

  }

  @action('getBasketSummary - basket-new state')
  async getBasketSummary() {
    return new Promise(((resolve, reject) => {
      this.basketsSummary.load().then((response) => {
        runInAction(() => {
          this.basketServiceCount = response.serviceCount || 0;
          this.basketHasAddress = true;
          this.basketFormattedAddress = response.formattedAddress;
          this.basketHasStartsAt = response.hasStartsAt;
          this.basketHasWorker = response.hasWorker;
        });

        return resolve(response);
      }).catch((err) => {
        if (__DEV__) {
          console.error(err);
        }

        // Setting count to 0 as default in case response is broken
        runInAction(() => {
          this.basketServiceCount = 0;
          this.basketHasAddress = false;
          this.basketFormattedAddress = null;
          this.basketHasStartsAt = false;
          this.basketHasWorker = false;
        });

        // This is unexpected so record it in Sentry
        if (isValidException(err)) {
          Sentry.captureException(err);
        } else {
          Sentry.captureMessage('Unhandled error getting basket summary');
        }

        return reject(err);
      });
    }));
  }

  @nonenumerable
  listeners = [];

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });

    // this.listeners.push();
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default BasketNewState;



// WEBPACK FOOTER //
// ./spa/state/basket-new.jsx